// extracted by mini-css-extract-plugin
export default {"impersonation-banner":"ImpersonationBanner_impersonation-banner__RcQSH"};